import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'
import _imports_1 from '@/assets/images/file_big_icon.png'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "file-upload-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-body" }
const _hoisted_5 = {
  key: 0,
  style: {}
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "popup-footer" }

import { ref, onMounted } from "vue";
import anncounceAPI from "../../api/announceAPI";
import codeAPI from "../../api/codeAPI";

// Props 정의: 요청파일정보를 객체로 처리

export default /*@__PURE__*/_defineComponent({
  __name: 'UploadContractPop',
  props: {
    공고순번: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// HTMLInputElement 타입을 명시적으로 지정
const fileInp = ref<HTMLInputElement | null>(null);
const 비고 = ref<string>("");

// file1 타입을 File | null로 지정
const file1 = ref<File | null>(null);
const 구분목록 = ref<{ id: string; text: string }[]>([]);
onMounted(async() => {
  await codeAPI.getSelectedCode('0002').then((res) => {
    구분목록.value = res.data.data.map((item: any) => { 
      return {id:item.코드,text:item.코드명}
    });
  });
})

const onDragOver = (event: DragEvent) => {
  event.preventDefault()
  ;(event.currentTarget as HTMLElement).classList.add('active')
  event.dataTransfer!.dropEffect = 'copy'
}
const onDragLeave = (event: DragEvent) => {
  (event.currentTarget as HTMLElement).classList.remove('active')
  event.preventDefault()
}

const onDrop = (event: DragEvent) => {
  event.preventDefault()
  const files = event.dataTransfer!.files
  if (files.length > 0) {
    const file = files[0] || null;
    file1.value = file;
  }
}
// 파일 업로드 처리
const addFile = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0] || null;
  file1.value = file;
};

const uploadFile = () => {
  if (!비고.value) {
    alert("파일 제목을 입력해주세요.");
    return;
  }
  if (!file1.value) {
    alert("파일을 첨부해주세요.");
    return;
  }

  if (props.공고순번 === null) {
    alert("공고순번이 null입니다. 파일 업로드를 진행할 수 없습니다.");
    return;
  }

  if (
    file1.value &&
    file1.value.type !== 'application/pdf' &&
    !file1.value.name.toLowerCase().endsWith('.pdf')
  ) {
    alert('PDF 파일만 업로드 가능합니다.')
    return
  }
  anncounceAPI
    .contractUploadFile(props.공고순번, 비고.value, file1.value)
    .then((res) => {
      if (res.data.success) {
        alert("등록이 완료되었습니다.");
        closePopup(true);
      }
    })
    .catch((error) => {
      console.error("파일 업로드 중 오류 발생:", error);
    });
};

// 팝업 닫기 처리
function closePopup(refresh: boolean) {
  emit("closePopup", { popupType: "fileUpload", refresh });
}

// 컴포넌트 초기화 처리
onMounted(() => {
  비고.value = "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "popup_title" }, "파일 첨부", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closePopup(false))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "popup_desc" }, "비고를 입력한 뒤 계약서를 첨부해주세요.", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((비고).value = $event)),
          class: "file_title",
          type: "text",
          placeholder: "비고"
        }, null, 512), [
          [_vModelText, 비고.value]
        ]),
        _createElementVNode("div", {
          class: "file_upload_area",
          onDragover: _withModifiers(onDragOver, ["prevent"]),
          onDragleave: _withModifiers(onDragLeave, ["prevent"]),
          onDrop: _withModifiers(onDrop, ["prevent"]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (fileInp.value?.click()))
        }, [
          (file1.value === null)
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, "파일 첨부 +"))
            : (_openBlock(), _createElementBlock("img", _hoisted_6)),
          (file1.value === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[6] || (_cache[6] = [
                _createTextVNode("또는"),
                _createElementVNode("br", null, null, -1),
                _createTextVNode("파일놓기")
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(file1.value?.name), 1))
        ], 32),
        _createElementVNode("input", {
          ref_key: "fileInp",
          ref: fileInp,
          class: "file_inp",
          type: "file",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (addFile($event)))
        }, null, 544)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "popup_close_btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (closePopup(false)))
        }, "취소"),
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: uploadFile
        }, "등록")
      ])
    ])
  ]))
}
}

})